'use client';

import { styled } from 'styled-components';
import TitleLabel from '../molecules/TitleLabel';
import ContentText from '../atoms/ContentText';
import { MdKeyboardArrowRight } from 'react-icons/md';
import Link from 'next/link';
import { BREAKPOINT_SP } from '@/util/const';
import { integ_informationAttributes } from '@/models/integ_information';

export type NewsMenuProps = {
  categoryCount: integ_informationAttributes[] & { total?: number };
  yearCount: integ_informationAttributes[] & { total?: number };
};

export default function NewsMenu(props: NewsMenuProps) {
  return (
    <Container>
      <div className="button-list">
        <TitleLabel type={'h-xs-sp'} $leftbar $underbar>
          カテゴリ
        </TitleLabel>
        <Link href={'/news'}>
          <MenuItem
            text={`すべて表示（${props.categoryCount.reduce(
              (total, current) => {
                return total + parseInt(current.total);
              },
              0,
            )}件）`}
          ></MenuItem>
        </Link>
        {props.categoryCount.map((categoryItem, index) => (
          <Link href={`/news?category=${categoryItem.category}`} key={index}>
            <MenuItem
              text={`${categoryItem.category}（${categoryItem.total}件）`}
            ></MenuItem>
          </Link>
        ))}
      </div>
      <div className="button-list">
        <TitleLabel type={'h-xs-sp'} $leftbar $underbar>
          アーカイブ
        </TitleLabel>
        {props.yearCount.map((timeItem, index) => (
          <Link href={`/news?year=${timeItem.public_year}`} key={index}>
            <MenuItem
              text={`${timeItem.public_year || '未知'}（${timeItem.total}件）`}
              key={index}
            ></MenuItem>
          </Link>
        ))}
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (max-width: ${BREAKPOINT_SP}) {
    gap: 16px;
  }
  .button-list {
    display: flex;
    flex-direction: column;
    a {
      color: inherit;
      text-decoration: none;
    }
  }
`;

const MenuItemWrapper = styled.div`
  border-bottom: 1px solid var(--gray-300-border, #d4d4d8);
  padding: 16px 12px 16px 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  &:hover {
    background-color: var(--bg-tertiary-gray-100, #f4f4f5);
    cursor: pointer;
  }
`;

type MenuItemProps = {
  text: React.ReactNode;
};

const MenuItem: React.FC<MenuItemProps> = ({ text }) => {
  return (
    <MenuItemWrapper>
      <ContentText type="article-l">{text}</ContentText>
      <MdKeyboardArrowRight size={28} color="var(--base-black, #18181B)" />
    </MenuItemWrapper>
  );
};
